<template>
    <div class="min-h-[100dvh] flex flex-col items-center justify-between gap-4 p-2">
        <div class="flex-1 flex items-center justify-center w-full">
            <div class="w-full max-w-md">

                <template v-if="loading">
                    <p>正在验证激活码...</p>
                </template>

                <template v-else>
                    <template v-if="valid">
                        <!-- 激活码有效，显示注册表单 -->
                        <div>
                            <div
                                class="bg-white/80 dark:bg-neutral-900/80 backdrop-blur-xl rounded-3xl shadow-sm border border-black/10 dark:border-white/10 overflow-hidden">
                                <div class="p-8 text-center">
                                    <h1
                                        class="text-3xl font-semibold text-neutral-900 dark:text-white mb-2 tracking-tight">
                                        {{ !chongzhi?'注册':'重置密码' }}
                                    </h1>
                                </div>
                                <form class="px-8 pb-10 space-y-4" @submit.prevent="submitRegister">
                                    <div v-if="!chongzhi" class="space-y-1">
                                        <label for="username"
                                            class="block text-sm font-medium text-neutral-700 dark:text-neutral-300">用户名</label>
                                        <input id="username" type="text" placeholder="username" required
                                            v-model="username" autocomplete="username" autocapitalize="off"
                                            autocorrect="off" spellcheck="false" v-model.trim="form.username"
                                            class="w-full px-4 py-3 bg-neutral-50 dark:bg-neutral-800/50 border border-neutral-200 dark:border-neutral-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 text-neutral-900 dark:text-white placeholder-neutral-400 dark:placeholder-neutral-500 transition-all duration-200 text-base" />
                                        <p v-if="errors.username" class="text-xs text-red-500 mt-1">{{
                                            errors.username }}</p>
                                    </div>

                                    <div class="space-y-1">
                                        <label for="password"
                                            class="block text-sm font-medium text-neutral-700 dark:text-neutral-300">密码</label>
                                        <div class="relative">
                                            <input id="password" :type="showPassword ? 'text' : 'password'"
                                                v-model="password" placeholder="********" required
                                                autocomplete="current-password"
                                                class="w-full px-4 py-3 bg-neutral-50 dark:bg-neutral-800/50 border border-neutral-200 dark:border-neutral-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 text-neutral-900 dark:text-white placeholder-neutral-400 dark:placeholder-neutral-500 transition-all duration-200 text-base pr-12" />
                                            <button type="button" @click="togglePasswordVisibility"
                                                class="absolute inset-y-0 right-0 pr-4 flex items-center text-neutral-400 hover:text-neutral-600 dark:hover:text-neutral-300 transition-colors"
                                                aria-label="切换密码显示">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="w-5 h-5"
                                                    style="cursor:pointer;">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                            </button>
                                        </div>
                                        <p v-if="errors.password" class="text-xs text-red-500 mt-1">{{
                                            errors.password }}</p>
                                    </div>

                                    <div v-if="!chongzhi" class="space-y-1">
                                        <label for="mail"
                                            class="block text-sm font-medium text-neutral-700 dark:text-neutral-300">邮箱</label>
                                        <input id="mail" type="text" placeholder="mail" required v-model="mail"
                                            autocomplete="mail" autocapitalize="off" autocorrect="off"
                                            spellcheck="false" v-model.trim="form.mail"
                                            class="w-full px-4 py-3 bg-neutral-50 dark:bg-neutral-800/50 border border-neutral-200 dark:border-neutral-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 text-neutral-900 dark:text-white placeholder-neutral-400 dark:placeholder-neutral-500 transition-all duration-200 text-base" />
                                        <p v-if="errors.mail" class="text-xs text-red-500 mt-1">{{
                                            errors.mail }}</p>
                                    </div>

                                    <p v-if="errorMsg" class="text-sm text-red-600 dark:text-red-400 text-center">{{
                                        errorMsg }}</p>

                                    <button type="submit" :disabled="loading"
                                        class="w-full px-6 py-4 bg-black dark:bg-white text-white dark:text-black font-semibold rounded-xl hover:bg-neutral-800 dark:hover:bg-neutral-100 transition-all duration-200 shadow-sm hover:shadow-sm transform hover:scale-[1.01] active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none text-base">
                                        <span v-if="!loading">{{ !chongzhi?'注册':'重置密码' }}</span>
                                        <span v-else>{{ !chongzhi?'注册中...':'重置密码中...' }}</span>
                                    </button>
                                </form>
                            </div>
                        </div>


                    </template>

                    <template v-else>
                        <!-- 激活码无效 -->
                        <p class="text-red-600 font-semibold">链接无效或激活码不存在。</p>
                    </template>
                </template>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { API_ENDPOINTS } from '@/api.js';


const router = useRouter()// 编程式跳转到首页

const route = useRoute()//获取当前路由对象（route），包含当前路径、参数、查询字符串等信息。
const code = route.params.code

const loading = ref(true)
const valid = ref(false)
const errorMsg=ref('')
const username = ref('')
const password = ref('')
const mali = ref('')
const chongzhi = ref(false)

const showPassword = ref(true)
const togglePasswordVisibility = () => {
    showPassword.value = !showPassword.value
}

const form = reactive({
    username: '',
    password: '',
    mail: '',
    remember: false
})

const errors = reactive({
    username: '',
    password: '',
    mail: ''
})


// 组件挂载后调用接口验证激活码
onMounted(async () => {
    try {
        // 假设后端接口：GET /api/activate/check?code=xxx
        const res = await axios.post(API_ENDPOINTS.login, {
            ac: 2,
            activate: code,
        }, {
            headers: { 'Content-Type': 'application/json' }
        })

        const data = res.data
        // 处理登录成功逻辑

        // 后端返回示例：{ valid: true } 或 { valid: false }
        // valid.value = res.data.valid === true
        valid.value = res.data.valid
        chongzhi.value = res.data.chongzhi ? res.data.chongzhi : false
        
    } catch (error) {
        valid.value = false
    } finally {
        loading.value = false
    }
})

// 注册提交示例
async function submitRegister() {
    if (!chongzhi.value) {
        if (!username.value || !password.value || !mail.value) return
    }

    try {
        // 假设后端注册接口 POST /api/register
        let postData;

        if (!chongzhi) {
            postData = {
                ac: 2,
                username: username.value,
                password: password.value,
                mail: mail.value,
                activate: code,
            };
        } else {
            postData = {
                ac: 2,
                password: password.value,
                activate: code,
                chongzhi: true,
            };
        }

        const res = await axios.post(API_ENDPOINTS.login, postData, {
            headers: { 'Content-Type': 'application/json' }
        });
        const data = res.data

        // 注册成功后跳转登录页或首页
        if (res.data.success) {
            alert(res.data.message)
            router.push('/login')
        } else {
            alert('注册失败，请重试。')
        }
    } catch (error) {
        alert('注册失败，请重试。')
    }
}
</script>
